<script setup>
function handleError() {
  clearError({
    redirect: '/',
  })
}
</script>

<template>
  <div>
    <div class="min-h-screen flex items-center">
      <div class="container">
        <h1
          class="mb-custom-md text-center text-[6rem] font-bold leading-[1.2] uppercase lg:text-[16rem] md:text-[13rem] sm:text-[10rem]"
        >
          404
        </h1>
        <p class="text-center text-3xl text-primary font-medium uppercase md:text-5xl sm:text-4xl">
          Page not found
        </p>
        <a aria-label="404 page not found" class="mx-auto mt-custom-xl flex justify-center" @click="handleError">
          <UIButton class="animate-bounce rounded-full capitalize" size="lg">
            <template #default>
              {{ $t('button.gohome') }}
            </template>
          </UIButton>
        </a>
      </div>
    </div>
  </div>
</template>

<style>
.dot-stretching {
  position: relative;
  width: 8px;
  height: 8px;
  border-radius: 5px;
  background-color: #FA2234;
  color: #FA2234;
  transform: scale(1.25, 1.25);
  animation: dot-stretching 2s infinite ease-in;
}
.dot-stretching::before, .dot-stretching::after {
  content: "";
  display: inline-block;
  position: absolute;
  top: 0;
}
.dot-stretching::before {
  width: 8px;
  height: 8px;
  border-radius: 5px;
  background-color: #FA2234;
  color: #FA2234;
  animation: dot-stretching-before 2s infinite ease-in;
}
.dot-stretching::after {
  width: 8px;
  height: 8px;
  border-radius: 5px;
  background-color: #FA2234;
  color: #FA2234;
  animation: dot-stretching-after 2s infinite ease-in;
}

@keyframes dot-stretching {
  0% {
    transform: scale(1.25, 1.25);
  }
  50%, 60% {
    transform: scale(0.8, 0.8);
  }
  100% {
    transform: scale(1.25, 1.25);
  }
}
@keyframes dot-stretching-before {
  0% {
    transform: translate(0) scale(0.7, 0.7);
  }
  50%, 60% {
    transform: translate(-20px) scale(1, 1);
  }
  100% {
    transform: translate(0) scale(0.7, 0.7);
  }
}
@keyframes dot-stretching-after {
  0% {
    transform: translate(0) scale(0.7, 0.7);
  }
  50%, 60% {
    transform: translate(20px) scale(1, 1);
  }
  100% {
    transform: translate(0) scale(0.7, 0.7);
  }
}
</style>
